enum OnboardingActionType {
    ONBOARDING_REQUEST_DATA = "ONBOARDING_REQUEST_DATA",
    ONBOARDING_LOAD_STEPS = "ONBOARDING_LOAD_STEPS",
    ONBOARDING_LOAD_FILES = "ONBOARDING_LOAD_FILES",
    ONBOARDING_DISPLAY_ERROR = "ONBOARDING_DISPLAY_ERROR",
}

export default OnboardingActionType;